<div class="card mb-5"> 
    <div class="card-header" style="border-bottom: none;">
        <div class="card-title d-flex flex-column">
            <h4>{{ data?.title | capitalCase }}</h4>
        </div>
    </div>
    <div class="card-body">
        <div id="{{data.widgetId}}" [style.height]="data?.height || 'var(--dvm-chart-height-lg, 58vh)'" style="width: 100%"></div>
    </div>
</div>